import { render } from "./VabeneOrderDetailsPage.vue?vue&type=template&id=12cae38a&scoped=true&ts=true"
import script from "./VabeneOrderDetailsPage.vue?vue&type=script&lang=ts"
export * from "./VabeneOrderDetailsPage.vue?vue&type=script&lang=ts"

import "./VabeneOrderDetailsPage.vue?vue&type=style&index=0&id=12cae38a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cae38a"]])

export default __exports__